import { Swiper, SwiperSlide } from "swiper/react"
import { Pagination, Autoplay } from "swiper/modules" // Import Pagination module
import "swiper/swiper-bundle.css" // Import Swiper styles
import { Box, Typography } from "@mui/material"
import { useTheme } from "@mui/material/styles"

import apple from "static/images/getting_started/apple.png"
import heart from "static/images/getting_started/heart.png"
import get_started from "static/images/getting_started/get_started.png"
import location from "static/images/getting_started/location.png"
import useTranslation from "hooks/use_translation"

const Carousel = () => {
  const { pages } = useTranslation()

  const theme = useTheme()
  const isRtl = theme.direction === "rtl"

  const items = [
    {
      title: pages?.home?.check_title,
      description: pages?.home?.check_description,
      src: heart,
    },
    {
      title: pages?.home?.review_title,
      description: pages?.home?.review_description,
      src: apple,
    },
    {
      title: pages?.home?.what_next_title,
      description: pages?.home?.what_next_description,
      src: get_started,
    },
    {
      title: pages?.home?.get_started_title,
      description: pages?.home?.get_started_description,
      src: location,
    },
  ]

  return (
    <Swiper
      modules={[Pagination, Autoplay]} // Enable Pagination and Autoplay
      slidesPerView={1}
      pagination={{ clickable: true }}
      autoplay={{ delay: 3000 }} // Autoplay every 3 seconds
      loop // Enable infinite loop
      dir={isRtl ? "rtl" : "ltr"}
    >
      {items.map((item, index) => (
        <SwiperSlide key={index}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              textAlign: "center",
              color: "white",
              flexFlow: 1,
              mt: 15,
            }}
          >
            <Box
              component="img"
              alt="Image"
              src={item.src}
              sx={{
                maxWidth: "250px",
                transform: isRtl ? "scaleX(-1)" : "none",
              }}
            />

            <Typography variant="h5" sx={{ fontWeight: 700, mt: 2 }}>
              {item.title}
            </Typography>
            <Typography variant="body1" sx={{ mb: 11 }}>
              {item.description}
            </Typography>
          </Box>
        </SwiperSlide>
      ))}
    </Swiper>
  )
}

export default Carousel
